import vue from 'vue'
import {
  getCity,
  getSupplierList,
  getCustomerList,
  getCompanyList,
  getUserList,
  getProductTree,
  uploadFile, getVisibleCompanyList
} from "@/services/common";


const state = {
  tableRow: vue.ls.get('tableRow'),
  cityTree: [],//省市区
  roleList: [],//角色list
  userList: [],//用户list
  supplierList: [],//供应商list
  customerList: [],//客户list
  productList: [],//产品list
  companyList: [],//公司list
  productTree: [],//产品规格树
  fileUrl: '',
  cropperVisible: false,
  visibleCompanyList: [],
};

const getters = {
  tableRow: () => state.tableRow ? state.tableRow : vue.ls.get('tableRow'),
  cityTree: () => state.cityTree,
  roleList: () => state.roleList,
  userList: () => state.userList,
  supplierList: () => state.supplierList,
  customerList: () => state.customerList,
  productList: () => state.productList,
  companyList: () => state.companyList,
  productTree: () => state.productTree,
  fileUrl: () => state.fileUrl,
  cropperVisible: () => state.cropperVisible,
  visibleCompanyList: () => state.visibleCompanyList,
};

const actions = {
  //省市区
  getCity({commit}) {
    getCity().then((res) => {
      commit('updateState', {state: 'cityTree', update: res.data});
    })
  },
  //用户list
  getUserList({commit, dispatch}, objc) {
    getUserList({size: 1000000, current: 1}).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'userList', update: res.data.records});
      }
    })
  },
  //公司list
  getCompanyList({commit, dispatch}, objc) {
    getCompanyList(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'companyList', update: res.data});
      }
    })
  },
  //供应商list
  getSupplierList({commit, dispatch}, objc) {
    getSupplierList(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'supplierList', update: res.data});
      }
    })
  },
  //客户list
  getCustomerList({commit, dispatch}, objc) {
    getCustomerList(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'customerList', update: res.data});
      }
    })
  },
  //产品规格树
  getProductTree({commit, dispatch}, objc) {
    getProductTree({}).then((res) => {
      if (res.code === 0 && res.data) {
        let arr = JSON.parse(JSON.stringify(res.data));
        let one = [];
        let two = [];
        arr.map((i) => {
          if (i.flattenSkuInfoList) {
            delete i.flattenSkuInfoList;
          }
          i.id = parseInt(i.id);
          if (i.treeSkuInfoList && i.treeSkuInfoList.length > 0) {
            i.treeSkuInfoList.map((j) => {
              j.id = parseInt(j.id);
              one.push(j);
              if (j.children && j.children.length > 0) {
                j.children.map((ob) => {
                  ob.id = parseInt(ob.id);
                  two.push(ob);
                })
              } else {
                delete j.children;
              }
            })
            i.children = i.treeSkuInfoList;
            delete i.treeSkuInfoList;
          }
        })
        commit('updateState', {state: 'productTree', update: arr});
      }
    })
  },
  //上传文件
  uploadFile({commit, dispatch}, objc) {
    uploadFile(objc.params).then((res) => {
      if (res.code == 0) {
        if (objc.title) {
          commit('updateState', {state: 'cropperVisible', update: false});
          commit('updateState', {state: objc.title, update: res.data});
        } else {
          commit('updateState', {state: 'cropperVisible', update: false});
          commit('updateState', {state: 'fileUrl', update: res.data});
        }
      }
    })
  },
  //可见公司待选list
  getVisibleCompanyList({commit, dispatch}, objc) {
    getVisibleCompanyList().then((res) => {
      if (res.code == 0) {
        commit('updateState', {state: 'visibleCompanyList', update: res.data})
      }
    })
  },
};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
    if (payload.state === 'tableRow') {
      vue.ls.set(payload.state, payload.update);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/common/modules/common.js